export default __webpack_public_path__ + "media/images/projekktor-maccaco/maccaco-9437ebc48f4ee1c99ffe0243c014ed0f.png";